import React from 'react';
import Media from 'react-media';
import MobileBanner from 'components/MobileBanner';
import styled from 'styled-components';
import { themes } from 'kb-shared';

const EmployerBenefitCTA = () => (
  <Media query={{ minWidth: themes.breakpoints.raw.tabletLandscape }}>
    {desktop => {
      if (desktop) {
        return (
          <EmployerBenefitText>
            Does your employer have the Kindbody benefit?{' '}
            <Link href="/kindbody-benefit">Sign Up to Activate</Link>
          </EmployerBenefitText>
        );
      }
      return (
        <MobileBanner>
          Does your employer have the Kindbody benefit?{' '}
          <Link href="/kindbody-benefit">Sign Up to Activate</Link>
        </MobileBanner>
      );
    }}
  </Media>
);

const EmployerBenefitText = styled.div`
  ${({ theme }) => theme.fonts.FoundersGrotesk}
  max-width: 280px;
  position: absolute;
  right: 1.5em;
  text-align: center;
  top: 1.5em;
`;

const Link = styled.a`
  font-weight: bold;
  text-decoration: underline;
`;

export default EmployerBenefitCTA;
